import React from 'react'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { translateToFormValues } from '../../quality-check-scheme-detail/components/utils'

const PreviewScenarioTag = ({ qcPlanDetail }: { qcPlanDetail: AIQualityCheckPlanDetailItem | null }) => {
  const translatedData = translateToFormValues(qcPlanDetail)
  return (
    <div style={{ paddingLeft: 10 }}>
      {translatedData?.nodeResults?.map((item, index) => (
        <div key={index} style={{ paddingTop: 10 }}>
          <div style={{ display: 'flex' }}>
            <span>
              板块:{item.moduleName}
            </span>
          </div>
          {item?.items?.map((subItem, subIndex) => (
            <div key={subIndex} className="rule-container">
              <span style={{ marginRight: '10px', marginTop: '6px' }}>
                <span>
                  标签{subIndex + 1}:{subItem?.name}
                </span>
              </span>
              <div style={{ display: 'inline-block', width: 'calc(100% - 10px)' }}>
                <div style={{ paddingLeft: 10 }}>
                  <div style={{ display: 'flex' }}>
                    <span style={{ width: 65 }}>具体描述:</span>
                    <span>
                      {subItem?.description}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default PreviewScenarioTag
